<template>
  <div class="qa-item-thread-navigation">
    <AppButton variant="outlined"
               data-locator="previous-question-button"
               :disabled="!question.previousInRoom"
               @click="() => getQuestion(question.previousInRoom)"
    >
      <font-awesome-icon class="mr-4" :icon="['far', 'chevron-left']" />
      {{ $t('project.question-answer.QuestionAnswerItemThreadNavigation.previousLabel') }}
    </AppButton>

    <AppButton
      variant="outlined"
      :to="{ name: QUESTION_ANSWER_LIST_ROUTE_NAME }"
      data-locator="back-qa-button"
    >
      {{ $t("project.question-answer.QuestionAnswerItemThreadNavigation.headerGoToQuestionList") }}
    </AppButton>

    <AppButton variant="outlined"
               :disabled="!question.nextInRoom"
               data-locator="next-question-button"
               @click="() => getQuestion(question.nextInRoom)"
    >
      {{ $t('project.question-answer.QuestionAnswerItemThreadNavigation.nextLabel') }}
      <font-awesome-icon class="ml-4" :icon="['far', 'chevron-right']" />
    </AppButton>
  </div>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'
import { QUESTION_ANSWER_ITEM_ROUTE_NAME, QUESTION_ANSWER_LIST_ROUTE_NAME } from '@/router/routerData'

export default {
  name: 'QuestionAnswerItemThreadNavigation',
  components: { AppButton },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      QUESTION_ANSWER_LIST_ROUTE_NAME,
    }
  },
  methods: {
    getQuestion (questionId) {
      this.$router.push({
        name: QUESTION_ANSWER_ITEM_ROUTE_NAME,
        params: {
          questionId: questionId,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

.qa-item-thread-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  gap: 12px;

  .v-btn {
    background: white;

    &::before {
      opacity: 0;
    }
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    flex-wrap: wrap;

    .v-btn {
      width: 100%;
    }
  }
}
</style>
